import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { adasStore } from './adas'

export const opportunityStore = defineStore('opportunity', {
  state: () => ({
    loading: {
      opportunity: false,
      opportunities: false,
      notes: false
    },
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filter: null,
      sortBy: 'asc',
      orderBy: 'user',
      searchTerm: '',
      status: null
    },
    opportunity: null,
    opportunities: {
      count: 0,
      items: []
    },
    notes: [],
    foundOpportunities: null,
    counts: null
  }),
  actions: {
    resetOpportunity() {
      this.opportunity = null
    },
    resetOpportunities() {
      this.opportunities = {
        count: 0,
        items: []
      }
    },
    setOpportunity(data) {
      switch (data.name) {
        case 'opportunity':
          this.opportunity = data.value
          break
        case 'line': {
          let found = this.opportunity.lines.find((element) => parseInt(element.adasInspectionResult) === parseInt(data.value.id))
          if (found) {
            this.opportunity.isOffer = true
            found.offerPrice = data.value.offerPrice
            found.isOverride = true
          }
          let offerPrice = 0
          this.opportunity.lines.forEach((element) => {
            if (element.adasInspectionResult !== null) {
              offerPrice += parseFloat(element.offerPrice)
            }
          })
          this.opportunity.offerPrice = offerPrice
          break
        }
        default:
          this.opportunity[data.name] = data.value
      }
      console.log('Set Opportunity', this.opportunity)
    },
    restoreListParams() {
      this.listParams = localStorage.getItem('opportunities_params') ? JSON.parse(localStorage.getItem('opportunities_params')) : this.listParams
    },
    setListParam(data) {
      this.listParams[data.name] = data.value
      localStorage.setItem('opportunities_params', JSON.stringify(this.listParams))
    },
    async getOpportunities(options) {
      this.resetOpportunities()
      this.loading.opportunities = true
      console.log('Get Opportunities', options)
      this.opportunities = await api.get('opportunity/opportunities', options)
      this.loading.opportunities = false
      if (this.opportunities) {
        if (this.opportunities.items) {
          this.opportunities.items.forEach((element) => {
            element.revenueShareFee = element.fee || 0
          })
        }
      }
      console.log('Got Opportunities', this.opportunities)
      return this.opportunities
    },
    async getOpportunity(data) {
      this.resetOpportunity()
      this.loading.opportunity = true
      this.notes = []
      this.opportunity = await api.get(`opportunity/opportunity?opportunity=${data.opportunity}&adasInspection=${data.adasInspection}`)
      if (this.opportunity) {
        if (this.opportunity.lines) {
          this.opportunity.lines.forEach((element) => {
            if (element.offerPrice === null || element.offerPrice === 0) {
              element.offerPrice = element.calibrationPrice
            }
          })
        }
      }
      this.notes = this.opportunity.notes
      this.loading.opportunity = false
      console.log('Got Opportunity', this.opportunity)
      return this.opportunity
    },
    async saveNotes(data) {
      return await api.post('opportunity/saveOpportunity?type=Notes', data)
    },
    async saveOpportunity() {
      return await api.post('opportunity/saveOpportunity', this.opportunity)
    },
    async saveOpportunityLines(data) {
      return await api.post('opportunity/saveOpportunity?type=Lines', data)
    },
    async saveStatus(data) {
      const storeAdas = adasStore()
      let results = null
      let found = this.opportunities.items.find((x) => parseInt(x.opportunity) === parseInt(data.opportunity))
      if (found) {
        found.status = data.status
        found.statusName = data.statusName
        if (found.status === 4) {
          found.deliveryDate = new Date().toISOString()
          storeAdas.setInspection({
            name: 'completed',
            value: found.deliveryDate
          })
        }
      }
      if (data.reason) {
        results = await api.post('opportunity/saveOpportunity?type=StatusWithNotes', data)
      } else {
        results = await api.post('opportunity/saveOpportunity?type=Status', data)
      }
      return results
    },
    async saveRequest(data) {
      return await api.post('opportunity/saveRequest?type=Update', data)
    },
    async getRequestNotes(data) {
      const storeAdas = adasStore()
      if (this.opportunity) {
        if (parseInt(this.opportunity.opportunity) === parseInt(data.opportunity)) {
          this.notes = []
          this.loading.notes = true
          this.notes = await api.get(
            `opportunity/requestNotes?calibrateRequest=${data.calibrateRequest}&opportunity=${data.opportunity}&readBy=${data.readBy}`
          )
          storeAdas.setInspection({
            name: 'notes',
            value: this.notes
          })
          this.opportunity.notes = this.notes
          this.loading.notes = false
          console.log('Got Notes', this.notes)
        }
      }
      return this.notes
    },
    async saveRequestNote(data) {
      return await api.post('opportunity/saveRequestNote', data)
    },
    async deleteRequestNote(id) {
      return await api.get(`opportunity/deleteRequestNote?calibrateRequestNote=${id}`)
    },
    async updateRequestFile(data) {
      await api.post(`opportunity/saveRequestFile`, data)
    },
    async pushToAdasMap(id) {
      return await api.get(`opportunity/push?opportunity=${id}`)
    },
    async getCounts(data) {
      this.counts = await api.get(`opportunity/counts?user=${data.user}&type=${data.type}`)
      console.log('Got Counts', this.counts)
      return this.counts
    }
  }
})
